<script>
  import { fade } from 'svelte/transition';
  import { currentPage } from './store';

  function handlePortfolioClick() {
      currentPage.set('projects');
    }
</script>

<div in:fade={{duration:500,delay:400}} out:fade={{duration:800,delay:0}} class="container flex flex-col justify-center h-full text-left mx-auto my-0">
  <h1 class="leading-none pb-10 text-6xl md:text-8xl lg:text-9xl hero-text">Declan M <br><i>Frontend Website<br>Development</i></h1>
  <h5 on:click={handlePortfolioClick} class="text-2xl font-thin hover:underline cursor-pointer">View Portfolio &#8594</h5>
</div>